<template>
    <div>
        <GooglePicker
            :multiple="true"
            button-text="Выбрать файлы из Google Диска"
            @file-selected="handleFileSelection"
            @error="handleError"
        >
            <template #button-content>
                <span>📁 Выбрать файлы</span>
            </template>
        </GooglePicker>

        <div v-if="selectedFiles.length > 0" class="selected-files">
            <h3>Выбранные файлы:</h3>
            <ul>
                <li v-for="file in selectedFiles" :key="file.id">
                    {{ file.name }} ({{ file.type }})
                </li>
            </ul>
        </div>
    </div>
</template>

<script setup>
import { ref } from 'vue'
import GooglePicker from "@/components/GooglePicker.vue";


const selectedFiles = ref([])

const handleFileSelection = (files) => {
    selectedFiles.value = files
    console.log('Выбранные файлы:', files)
}

const handleError = (error) => {
    console.error('Ошибка Google Picker:', error)
    alert(`Ошибка: ${error}`)
}
</script>